/*
    价格保护
    @author: wanghui@gwdang.com
 */


import '../../css/price_protect.css'

import Utils from '../../js/utils/utils'
import { keep2Decimals } from '../../js/utils/Number'
import QrCode from '../../Service/QrCode'
import TransUrl from '../../Service/TransUrl'
import PriceProtect from '../../Model/PriceProtect'

import Vue from '../../js/vue-2.2.0.min'

let tpl = $('#tpl_now').text();

console.log(location.hostname)
if (location.hostname === 'www.bijiago.com') {
    tpl = 'fake';
}

/**
 * @param tag 1 未登录 2 未绑定公众号
 */
function tipBanner(tag = 1, qrcodeSrc = '') {
    let content = '';
    if (tag === 1) {
        content = '<div><strong>下单前，先登录</strong>&nbsp;&nbsp;<span>及时获取价格保护提醒</span> <span class="show-login ml-20"><strong>立即登录</strong></span></div>'
    }

    if (tag === 2) {
        if (! qrcodeSrc) {
            qrcodeSrc = 'https://www.gwdang.com/template/metro/images/tool/app_qrcode@2x.png';
        }
        content = `<div><strong>扫码关注公众号</strong>&nbsp;&nbsp;<span>及时获取价格保护提醒</span> <img class="qrcode pos_r ml-20 vm" src="${qrcodeSrc}"></div>`
    }

    let html = `
<div class="tip-banner" id="price-protect">
    <div class="wrapper pos_r tc white font15">
    ${content}
      <span class="close-pp-tip-banner pos_a" onclick="$(this).parents('#price-protect').remove();"><img src="/images/tb_double11/2019/web_banner_close.png"></span>
    </div>
</div>
    `;

    return html
}

async function getQrcodeSrc (uid, callback) {
    try {
        const src = await QrCode.getBindQrCode(uid);
        callback && typeof callback === 'function' && callback(src);
    } catch (e) {}
}

// 价保方式购买上报
function buyReport (dp_id, title, img, url, pid, uniq_id = '') {
    PriceProtect.reportEvent(dp_id, title,img, url, pid, uniq_id).then(resp => {
    }).catch(err => {
        // todo report error
       console.error(err);
    });
}

/**
 * 价格保护转链购买
 * @param dp_id
 * @param title
 * @param img
 * @param url
 * @param position
 * @param is_coupon
 * @param new_tab 新窗口打开
 */
function goByPriceProtect (dp_id, title, img, url, position, is_coupon = false, new_tab = false) {
    let transed_u;
    if (is_coupon) {
        transed_u = url;
    } else {
        transed_u = `/union/go/?site_id=3&target_url=${encodeURIComponent(url)}&union=gwdang&column=dp&crc64=1`;
    }
    TransUrl.transItem(dp_id, position, url, is_coupon).then(data => {
        if (data[dp_id]) {
            transed_u = data[dp_id];
            let pid = data['pid'] || '';
            // 上报
            buyReport(dp_id, title, img, url, pid);
        }
    }).catch(err => {
        console.error(err);
        // todo trans url error
    }).finally(() => {
        if (new_tab) {
            window.open(transed_u)
        }else {
            window.location.href = transed_u
        }
    })
}


if (tpl === 'mine_price_protect') {
    // 个人中心-价格保护
    Vue.component('dp-item', {
        template: '#dp-item',
        filters: {
            keep2Decimals,
        },
        props: {
            invalidList: {
                type: Boolean,
                default: false,
            },
            index: {
                type: Number,
                default: 0
            },
            // 批量操作
            isBatchEdit: {
                type: Boolean,
                default: false,
            },
            item: {
                type: Object,
                default () { return {} }
            },
            selected: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isEdit: false,
            }
        },
        methods: {
            del () {
                this.$emit('del', this.item.id)
            },
            select () {
                this.$emit('select-item', this.item.id);
            },
        },
        watch: {
            isBatchEdit (newV) {
                if (newV) this.isEdit = false;
            },
        },
        computed: {
            showDel () {
                return this.isEdit || this.isBatchEdit;
            },
            priceProtectAmount () {
                if (this.item.price) {
                    return this.item.price.paid_price - this.item.price.current_price
                }
                return 0
            },
        }
    });
    new Vue({
        el: '#app-price-protect',
        data: {
            dps: [],
            ps: 30,
            pg: 1,
            inputPage: 1,
            showInvalid: false,
            options: {
                enable: false,
                all: false,
            },
            end: false,
            loading: false,

            selectedArr: [],
            showDelPopup: false,
        },
        mounted () {
            this.getData();

            // 二维码
            if (uid && ! Number(is_wx_bind)) {
                getQrcodeSrc(uid, function (src) {
                    $('#app-price-protect .qrcode>img').attr('src', src);
                });
            }
        },
        methods: {
            goto (pg = 1) {
                if (pg > 0) {
                    if (this.dps.length < this.ps) {
                        return ;
                    }
                    this.clearData();
                    this.pg = pg;
                    this.getData();
                }
            },

            selectDp (id) {
                if (this.selectedArr.indexOf(id) > -1) {
                    this.selectedArr = this.selectedArr.filter(item => {
                        return item != id
                    })
                } else {
                    this.selectedArr.push(id)
                }
            },

            clearData () {
                this.pg = 1;
                this.loading = false;
                this.end = false;
                this.dps = [];
                this.selectedArr = [];
                this.options.enable = false;
                this.options.all = false;
            },

            async getData () {
                if (this.loading || this.end) {
                    return false;
                }

                this.loading = true;
                try {
                    let r = await PriceProtect.getList(this.pg, this.showInvalid);
                    this.dps = r.list;
                } catch (e) {
                } finally {
                    this.loading = false;
                }
            },

            delOption () {
                if (this.selectedArr.length) {
                    this.toggleDelPopup()
                }
            },

            toggleDelPopup () {
                this.showDelPopup = ! this.showDelPopup
            },

            deleteDp (id) {
                this.deleteData(isNaN(id) ? '' : id)
            },

            async deleteData (id) {
                let deleteIds = id ? [id] : this.selectedArr;

                try {
                    let r = await PriceProtect.delete(deleteIds);
                    if (r) {
                        this.clearData();
                        this.getData();
                    }
                } catch (e) {}
                finally {
                    this.showDelPopup = false;
                }
            },
        },
        watch: {
            showInvalid () {
                this.clearData();
                this.getData();
            },
            'options.enable': function (newV) {
                if (! newV) {
                    this.options.all = false;
                    this.selectedArr = [];
                }
            },
            'options.all': function (newV) {
                if (newV) {
                    this.dps.map(item => {
                        this.selectedArr.push(item.id)
                    })
                } else {
                    this.selectedArr = [];
                }
            },
        }
    });
}


else if (tpl === 'product_show_wechat') {
    // 价格保护扫码中间页
    if (! uid.length) {
        window.location = Utils.UrlParams().url
    }

    let is_coupon = Utils.UrlParams().is_coupon || 0;
    let url = origin_url;
    let p = position ? position : 'jiabao_product';

    if (Number(is_wx_bind)) {
        goByPriceProtect(dp_id, title, img_url, url, p, is_coupon);
    } else {
        getQrcodeSrc(uid, function (src) {
            let img = new Image();
            img.src = src;
            $('#price-protect-bind-wechat .qrcode-wrapper').append(img);
        });

        $('.button').on('click', function (e) {
            e.preventDefault();
            goByPriceProtect(dp_id, title, img_url, url, p, is_coupon);
        })
    }
}

else {
    // 单品比价页/历史价格查询页
    let tag = 0;
    if (uid) {
        if (! Number(is_wx_bind)) tag = 2;
    } else {
        tag = 1;
    }

    if (tag === 1 || tag === 2) {

        // 未登录
        if (tag === 1) {
            $('body').append(tipBanner(tag));
            $('.tip-banner#price-protect .show-login').click(function () {
                $('#pop_login').show();
                $('#pop_mask').show();
                Utils.Cookies.removeItem('redirect_url');
            });

            $('.buy-section .buy-price-protect .buy').on('click', function (e) {
                _hmt && _hmt.push(['_trackEvent', 'www', '点击', '价保购买']);
                e.preventDefault();
                $('#pop_login').show();
                $('#pop_mask').show();

                let is_coupon = $(this).data('is-coupon');
                let url = is_coupon ? $(this).attr('href') : origin_url;
                const p = tpl === 'trend' ? 'jiabao_trend' : 'jiabao_product';
                let target_url = `/product/show_wechat?url=${encodeURIComponent(url)}&dp_id=${dp_id}&site_id=${site_id}&is_coupon=${is_coupon}&p=${p}`;
                Utils.Cookies.setItem('redirect_url', encodeURIComponent(target_url), 5 * 60);
            });
        }

        // 未绑定公众号
        if (tag === 2) {
            // 绑定二维码
            $('.buy-price-protect .tip-qrcode>span').addClass('hover-qrcode').addClass('undL');

            $('.buy-section .buy-price-protect .buy').on('click', function (e) {
                e.preventDefault();
                _hmt && _hmt.push(['_trackEvent', 'www', '点击', '价保购买']);
                let is_coupon = $(this).data('is-coupon');
                let url = is_coupon ? $(this).attr('href') : origin_url;
                const p = tpl === 'trend' ? 'jiabao_trend' : 'jiabao_product';
                window.open(`/product/show_wechat?url=${encodeURIComponent(url)}&dp_id=${dp_id}&site_id=${site_id}&is_coupon=${is_coupon}&p=${p}`);
            });

            setTimeout(function () {
                getQrcodeSrc(uid, function(src) {
                    $('body').append(tipBanner(tag, src));
                    $('.buy-section .buy-price-protect .qrcode>img').attr('src', src);
                })
            }, 300);

            $('.buy-section .buy-price-protect .hover-qrcode').hover(function () {
                $('.buy-section .buy-price-protect .qrcode').show()
            }, function () {
                $('.buy-section .buy-price-protect .qrcode').hide()
            });
        }
    } else {
        // 登录并绑定了公众号
        $('.buy-section .buy-price-protect .buy').on('click', function (e) {
            _hmt && _hmt.push(['_trackEvent', 'www', '点击', '价保购买']);
            e.preventDefault();

            let is_coupon = $(this).data('is-coupon');
            let url = is_coupon ? $(this).attr('href') : origin_url;
            let p = tpl === 'trend' ? 'jiabao_trend' : 'jiabao_product';
            goByPriceProtect(dp_id, title, img_url, url, p, is_coupon, true);
        })
    }

}


